import { render } from "./Landing.vue?vue&type=template&id=431c6554&scoped=true&ts=true"
import script from "./Landing.vue?vue&type=script&lang=ts"
export * from "./Landing.vue?vue&type=script&lang=ts"

import "./Landing.vue?vue&type=style&index=0&id=431c6554&lang=css"
import "./Landing.vue?vue&type=style&index=1&id=431c6554&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ivan\\Desktop\\PROJECTS\\econom.landing-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-431c6554"]])

export default __exports__